import { jsx as _jsx } from "react/jsx-runtime";
import { BLOB_BASE } from '../../../../common/constants';
const ResultPhoto = (props) => {
    return props.photo === null
        ? _jsx("span", { className: "tour-stop-thumb", "aria-hidden": "true", children: _jsx("i", { className: `bi ${props.icon}` }) })
        : _jsx("img", { className: "tour-stop-thumb", src: `${BLOB_BASE}/${props.photo}`, alt: "" });
};
export default ResultPhoto;
